import Sidebar from './Sidebar.jsx';
import TopBar from './TopBar.jsx';

export default function Layout({
  title,
  children,
  stats,
  statsLoading,
  activeQuickFilter,
  onQuickFilter,
}) {
  return (
    <div className="layout">
      <Sidebar
        stats={stats}
        statsLoading={statsLoading}
        activeQuickFilter={activeQuickFilter}
        onQuickFilter={onQuickFilter}
      />
      <main className="main">
        <TopBar title={title} />
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
